<!-- background overlay: clicking it closes the menu/login -->
<div id="backgroundOverlay"
     class="fade-in"
     *ngIf="!isCollapsed"
     (click)="onBackgroundClick($event)">
</div>

<!-- menu button: only toggle the SlideMenu; stop propagation -->
<button id="menuBtn"
        #btn
        type="button"
        pButton
        icon="k-icon k-i-rows"
        (click)="onMenuButtonClick($event)">
</button>

<!-- user menu (clicks inside should not close the slide menu) -->
<div id="menuUser"
     class="login-menu row"
     *ngIf="!isCollapsed"
     (click)="$event.stopPropagation()">
  <div class="user-icon"><span class="k-icon k-i-user"></span></div>
  <span class="user"><strong>{{greetingLanguageLabel}},&nbsp;</strong>{{ childMessage }}</span>
  <div class="cancel-menu">
    <a class="mobile-header-cancel k-icon k-i-close"
       (click)="closeAll($event)"></a>
  </div>
</div>

<!-- PrimeNG SlideMenu: popup, appended to body, no autoDisplay -->
<p-slideMenu #menu [model]="items" [popup]="true" id="newSlideMenu" [appendTo]="'body'"
             [autoDisplay]="false"
             (onHide)="onMenuHide()">
</p-slideMenu>
<div id="howToArrow"></div>


<span class="down-arrow" *ngIf="downsidearrow==true" ></span>
